import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getTokenRole } from '../utils/jwt';
import './Dashboard.css';

const AdminLogin = () => {
	const [loginData, setLoginData] = useState({ email: '', password: '' });
	const [errors, setErrors] = useState({});
	const [isSubmitting, setIsSubmitting] = useState(false);
	const navigate = useNavigate();

	const handleChange = (e) => {
		const { name, value } = e.target;
		setLoginData(prev => ({ ...prev, [name]: value }));
		if (errors[name]) setErrors(prev => ({ ...prev, [name]: '' }));
	};

	const getOrGenerateDeviceId = () => {
		let deviceId = localStorage.getItem('deviceId');
		if (!deviceId) {
			deviceId = window.crypto.randomUUID
				? window.crypto.randomUUID()
				: 'manual-fallback-uuid-' + Date.now();
			localStorage.setItem('deviceId', deviceId);
		}
		return deviceId;
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		const temp = {};
		if (!/\S+@\S+\.\S+/.test(loginData.email)) temp.email = 'Invalid email format.';
		if (!loginData.password) temp.password = 'Password is required.';
		setErrors(temp);
		if (Object.keys(temp).length) return;

		setIsSubmitting(true);
		try {
			const response = await fetch('/api/v1/auth/login', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
					'X-Device-Id': getOrGenerateDeviceId()
				},
				body: JSON.stringify(loginData)
			});

			if (response.ok) {
				const { accessToken, refreshToken, tokenType, expiresIn } = await response.json();
				if (getTokenRole(accessToken) !== 'ADMIN') {
					setErrors({ general: 'This account is not an admin. Access denied.' });
					return;
				}
				localStorage.setItem('adminAccessToken', accessToken);
				localStorage.setItem('adminRefreshToken', refreshToken);
				localStorage.setItem('adminTokenType', tokenType || 'Bearer');
				localStorage.setItem('adminExpiresAt', String(Date.now() + (expiresIn || 3600) * 1000));
				navigate('/admin');
			} else {
				let message = 'Login failed';
				try {
					const errorData = await response.json();
					message = errorData.message || message;
				} catch { /* ignore */ }
				setErrors({ general: message });
			}
		} catch (error) {
			console.error(error);
			setErrors({ general: 'Network error.' });
		} finally {
			setIsSubmitting(false);
		}
	};

	return (
		<div className="registration-container">
			<form className="registration-form" onSubmit={handleSubmit}>
				<h2>Admin Login</h2>
				<p style={{ color: '#666', marginBottom: 16, fontSize: '0.9rem' }}>
					WhatsApp control panel
				</p>

				<div className="form-group">
					<input
						name="email"
						type="email"
						placeholder="Admin email"
						onChange={handleChange}
						className={errors.email ? 'input-error' : ''}
						required
					/>
					{errors.email && <span className="error-text">{errors.email}</span>}
				</div>

				<div className="form-group">
					<input
						name="password"
						type="password"
						placeholder="Password"
						onChange={handleChange}
						className={errors.password ? 'input-error' : ''}
						required
					/>
					{errors.password && <span className="error-text">{errors.password}</span>}
				</div>

				{errors.general && (
					<div className="error-text" style={{ textAlign: 'center', marginBottom: 10 }}>
						{errors.general}
					</div>
				)}

				<button type="submit" disabled={isSubmitting} className="submit-btn">
					{isSubmitting ? <div className="loader"></div> : 'Login'}
				</button>
			</form>
		</div>
	);
};

export default AdminLogin;
